import { render } from "./SavHome.vue?vue&type=template&id=ac229336&scoped=true&ts=true&lang=pug"
import script from "./SavHome.vue?vue&type=script&lang=ts"
export * from "./SavHome.vue?vue&type=script&lang=ts"

import "./SavHome.vue?vue&type=style&index=0&id=ac229336&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac229336"]])

export default __exports__